import React from "react";
import tawaran from "../asset/mencoba-jadi-team-lead-satu-bulan/tawaran.png";
import tl1 from "../asset/mencoba-jadi-team-lead-satu-bulan/tl1.png";
import tl2 from "../asset/mencoba-jadi-team-lead-satu-bulan/tl2.png";
import kantorclient from "../asset/mencoba-jadi-team-lead-satu-bulan/kantor-client.jpg";

class TrialLead extends React.Component {
  render() {
    return (
      <>
        <div className="container pt-4 pb-4 content-detail">
          <div className="header pb-4">
            <h1 className="font-PoppinsBold">
              Mencoba Jadi <span className="font-green">Team Lead</span> Dalam
              Satu Bulan 👾.
            </h1>
            <span className="font-PoppinsBold mx-1 text-grey">11-01-2026</span>
          </div>
          <div className="nav-content shadow-sm p-3 mb-5">
            <h2 className="font-PoppinsBold">Opening</h2>
            <p className="text text-justify pb-2">
              Disuatu siang yang cerah, hari itu saya sedang mengerjakan task
              kerjaan saya seperti biasa, tiba tiba notif muncul ditelegram
              saya, chat dari senior divisi saya pun muncul, sebenarnya hal
              biasa di chat sir satu ini, tapi ada yang menarik dari chat
              disiang itu, biasanya sir satu ini akan mengechat bertanya,
              progres pekerjaan, teknik teknik yang sudah dilakukan didalam
              pekerjaan atau bantuann lainnya. namun kali ini sedikit berbeda,
              beliau menawarkan saya untuk mencoba menjadi lead di project yang
              akan datang :u ?
            </p>
            <img src={tawaran} className="img-fluid pb-1" alt="Responsive" />
            <p className="text text-justify pb-2">
              Hal menarik yang menurut saya harus saya coba, karena pada saat
              itu pemikiran saya, murni belajar dan experience saya kedepannya
              (ada hal hal yang saya mau lihat di pov saya bukan sebagai
              engineer), terkadang saya tertarik dengan manajerial, seperti apa
              dibelakang suatu project tanpa pov enginer ketahui, sehingga
              project itu berjalan dengan lancar, sebenarnya saya sudah expect
              beberapa momen yang akan terjadi:
              <ul>
                <li>1. Akan banyak bersinggungan dengan Project Manager ?</li>
                <li>
                  2. Akan banyak bersinggungan dengan Team Security Client ?
                </li>
                <li>3. Tanggung jawab terhadap hasil kerja team</li>
                <li>4. Akan banyak harus jawab pertanyaan tim developer ?</li>
              </ul>
              yapp list diatas sudah saya predict, menurut saya ini hal yang
              baru dan menarik buat saya coba, disamping itu saya rasa, saya
              sudah beberapa kali melihat team lead yang ada sebagai contoh saya
              dalam cosplay team lead, ditambah saya beberapa kali bersinggungan
              dengan PIC jika ada project yang bersinggungan dengan alat yang
              ditaruh di klien.
            </p>
            <h2 className="font-PoppinsBold">The Project Is Coming ...</h2>
            <img src={tl1} className="img-fluid pb-1" alt="Responsive" />
            <br />
            <img src={tl2} className="img-fluid pb-1" alt="Responsive" />
            <p className="text text-justify pb-2">
              Sebelum itu mari kita jelaskan posisi saya terlebih dahulu, saya
              bekerja sebagai security consultant, sederhana nya 1 project
              terdiri dari 3 orang (junior,enginer,team,lead) posisi saya saat
              ini enginer. menjadi team lead tentu hal baru sekali bagi saya,
              tentu saya akan dihadapi sejuta pertanyaan yang akan dilempar,
              baik di meeting, setelah meeting, bahkan hingga setelah bekerja
              kwkwkwkw.
            </p>
            <h2 className="font-PoppinsBold">Preperation Time</h2>
            <p className="text text-justify pb-2">
              Sebelum memulai project, kita sebagai seorang consultant, harus
              mempelajari dokumen dokumen klien kita, baik dari flow apps, infra
              apps, fitur, objective app, dan lain lain. pada tahap ini akan
              menentukan, bagaimana scenario test case yang bisa jadi concert
              utama kita pada suatu app, issue issue yang relevant, serta
              possible timeline. sebagai pov enginer, tentu saya biasanya hanya
              menunggu dokumen, serta data data yang kami request, untuk kami
              checking sebelum app mulai, lalu bagaimana ketika saya mencosplay
              jadi lead, amazzzing ternyata tidak semudah itu, justru kita yang
              concern terhadap data data tersebut, apakah data A ini memang
              perlu diprovide ? apakah kita memerlukan konektivitas lain ? dan
              yang paling wow apakah kita bisa onsite ?, semua diluar dugaaan
              saya kwkwkw sebagai pov engineer. setelah melakukan preparation
              yang menarik adalah project kali ini memiliki target yang sangat
              confidential (kami diharuskan untuk hadir dikantor klien kami
              semasa timeline berjalan).
            </p>
            <img
              src={kantorclient}
              className="img-fluid pb-1"
              alt="Responsive"
            />
            <p className="text text-justify pb-2">
              Siang itu, tibalah kamu dikantor klien kami, udara nya sejuk hari
              itu, rill tidak panas, tapi tidak dengan otak saya wkwwk,
              sepanjang perjalanan saya berfikir, segudang pertanyaan apa aja
              yang akan dilempar kesaya ini, akhirnya meeting berjalan, dev
              menjelaskan kami flow app, infra, alasan kenapa harus onsite
              (confidential) dan lain lain. tapi saya menemukan suatu yang
              menarik, seperti nya alasan onsite tidak relevant, saya rasa ini
              bisa diimplement cara lain sehingga kami bisa mengerjakan kerjaan
              ini secara hybrid atau jarak jauh, yang menarik saran saya
              diterima wowww (phase 1 berhasil, menegoisasi klien) tentu saya
              merasa senang karena argumentasi saya dapat diterima dan tentu
              mempermudah tim saya memiliki banyak waktu dibanding harus
              kekantor klien setiap hari.
            </p>
            <h2 className="font-PoppinsBold">Memasuki Timeline</h2>
            <p className="text text-justify pb-2">
              Project akhirnya berjalan, seperti biasa kita memulai melakukan
              beberapa scenario pada aplikasi kami, namun yang menarik ketika
              menjadi team lead ada hal yang berbeda, proposi project bukan lagi
              seperti yang biasa saya lalukan. biasanya saya sebagai engineer
              tentu akan menggunakan waktu saya 80% fokus terhadap teknikal
              dalam project tersebut, disini saya belajar hal lain, ketika
              menjadi team lead teknikal ini hanya dapat di gunakan 40%, sisanya
              60% saya harus sering menkonfirm bawa project berjalan dengan baik
              tanpa ada kendala. dimulai dari menanyakan progress enginer,
              apakah ada data lain yang dibutuhkan, apakah scenario yang sudah
              kami concern relevant dengan project. dan yang pasti saya harus
              standby setiap Project Manager bertanya tentang project tersebut.
              Dari sini saya mulai melihat banyak POV lain, selama kita jadi
              engineer kita akan tau apa yang kita kerjakan apa yang kita
              temukan, namun jadi team lead terdapat perspektif lain, bayangkan
              bagaimana seorang team lead yang hanya handle teknikal 40% harus
              bisa menjawab pertanyaan pertanyaan yang dilemparkan oleh client
              dan internal team ? (saya baru menyadari ini wkwkwk), jawaban nya
              adalah catchup team (hal yang bener bener saya pelajari), sebagai
              team lead kita harus bisa bertanya progress dan sejauh apa tim
              kita melakukannya tanpa kita menjadi seorang team lead yang sangat
              rewel, saya rasa (ini part yang lumayan sulit). disamping itu,
              kita juga harus mempelajari setiap temuan yang team kita temukan,
              dari sini saya paham kenapa tetap ada 40% teknikal yang harus kita
              check (tentu supaya team juga paham, dan bisa fast learning
              terhadap apa yang engineer temukan).
              <br /> <br />
              Setelah permasalahan team, ada permasalaahan lain kwkwk (ketika
              saya jadi engineer ada issue saya cukup followup ke team lead,
              nanti mungkin akan saya konfirm ke team dev jika memang di
              perbolehkan followup secara langsung), namun kali ini berbeda,
              sebagai team lead, kita menjadi penyambung, antara team, project
              manager, dan klient, lagi lagi fleksibelitas, ketersediaan, dan
              fast learning disini harus dilakukan. diluar itu team lead juga
              akan menghandle pertanyaan-pertanyan dari team internal klien,
              apakah testcase A dilakukan ? apa alasan tidak dilakukan ? sejauh
              apa kalian melakukan ? semua ini menjadi tanggung jawab team lead.
              Lagi lagi ada yang menarik, ketika engineer berhasil menemukan
              Celah A ? lalu bagaimana tim aplikasi ternyata tidak bisa
              melakukan fixing terhadap celah tersebut ? bertentangan dengan
              bisnis ? waktu fixing yang memakan waktu lama ? woww diluar
              expetasi saya kwkwk lagi lagi kita sebagai team lead yang harus
              menghandle ini secara professional, disatu sisi internal klien
              ingin tidak ada issue, disatu sisi dev tidak bisa karena alesan
              tertentu, (sense of negotation lagi lagi harus dilakukan), namun
              disatu sisi kita juga harus memiliki integritas. lalu apa yang
              harus dilakukan, ternyata ada banyak dokumen yang bisa digunakan
              untuk kondisi tersebut. lagi lagi saya sebagai engineer harus
              belajar dengan cepat Beragam dokumen saya pelajari, apa itu MOM
              (minutes of meeting), Waiver, RA, dan lain lain. Satu lagi ada hal
              yang saya pelajari dalam menjadi team lead, yaitu setiap kata
              dalam meeting adalah hal penting, ketika saya menjadi engineer,
              kadang saya lebih suka part ketika membicarakan teknikal project
              terkait, namun ketika jadi team lead semua berbeda, bisa jadi
              setiap kata kata yagn keluar dari orang dalam meeting tersebut,
              justru akan menjadi pertanyaan bagi kita ? tentu siapa yang harus
              menjawab ? tidak mungkin saya menyuruh engineer, project manager,
              menjawab dengan alesan saya tidak dengar / tidak paham kwwkkw,
              semua menjadi tanggung jawab team lead. terakhir bagi saya,
              seperti nya saya harus belajar mengurangi rasa tidak enak dan
              profesional, ketika jadi team lead, tentu kami akan memberikan
              segudang perintah kepada team kami, seperti make sure perilaku A,
              request dipersiapkan report, retest dan lain lain. sebuah hal yang
              menemurut saya awkward untuk menyuruh hal hal tersebut ke sesama
              rekan. tapi dibalik itu semua kami berhasil menyelesaikan project dengan baik.
            </p>
            <h2 className="font-PoppinsBold">Last</h2>
            <p className="text text-justify pb-2">
              Saya rasa, saya masih harus banyak belajar menjadi team lead, dan
              mungkin saya lebih senang untuk diam dan bekerja untuk saat ini,
              pengalaman ini sangat berharga bagi saya, dan menjadi catatan
              untuk saya ternyata masih banyak sekali hal hal kecil didunia
              pekerjaan saya yang harus saya pelajari diluar teknikal.
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default TrialLead;

